module.exports = "\r\n<strong ng-class=\"{'visible-xs' : isExpandedLargeFormat}\"><a bws-scroll-to-element=\"expandable-content\" class=\"link--secondary\" href=\"\" ng-click=\"toggleContent()\" >{{ isExpanded == true ? 'Hide' : 'View' }} {{ textContent }}</a></strong>\r\n<ng-transclude scroll-to-element-target=\"expandable-content\" ng-show=\"isExpanded\" class=\"js-expandable-content\" tabindex=\"-1\"></ng-transclude>\r\n\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/common/components/expandable-content/expandable-content-template.html
 ** module id = 846
 ** module chunks = 2
 **/